module.exports = __webpack_public_path__ + "static/media/zz3M.6df5b33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/zz3M.png
// module id = 296
// module chunks = 0